import React from "react";
import { useSelector } from "../../store";
import { TcForBR } from "../../components/v2/TcForBR";
import { Tc } from "../../components/v2/Tc";

export const TermsAndConditions: React.FC = () => {
  const country = useSelector((state) => state.data.country);
  return <>{country === "BR" ? <TcForBR /> : <Tc />}</>;
};
